import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import ReactDom from 'react-dom';
import {push} from 'react-router-redux';
import queryString from 'query-string';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh, clearSelection, updateItem} from '../../paginator/actions';
import {fetchInformation} from '../../containers/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import Order from './order'; 
import Invoice from './invoice';
import { host_v2 } from '../../utilities/requests';


export default class Orders extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
        incomplete: false,
    }

    state ={
        representivates: []
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        ...this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
            ? [
                {field: 'username', label: window.gettext('Username')},
                {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
                {field: item => `${item.cell_phone.persian()}${window.gettext(',')} ${(item.phone || '').persian()}`, label: window.gettext('Contact')},
                {field: item => item.store_item_names, label: 'نام محصول'},
                {field: 'region_display', label: window.gettext('Region')},
                {field: 'city_display', label: window.gettext('City')},  
                ...this.props.location.query.item
                    ? [
                        {
                            field: item => (_.find(
                                item.items,
                                item => String(item.item) === this.props.location.query.item,
                            ) || {count: 0}).count.persian(),
                            label: window.gettext('Count'),
                        },
                    ]
                    : [
                        {field: item => item.price ? item.price.persian() : '-', label: window.gettext('Price')},
                        {field: item => item.weight ? item.weight.persian() : '-', label: window.gettext('Weight')},
                        {
                            field: item => ({
                                0: window.gettext('Bank gateway'),
                                1: window.gettext('Draft'),
                                2: window.gettext('No Payment / Free'),
                                3: window.gettext('Debtor'),
                            }[item.payment_method]),
                            label: window.gettext('Payment Method'),
                        },
                        {
                            field: item => ({
                                // 0: window.gettext('Bespoke Post'),
                                // 1: window.gettext('Pishtaz Post'),
                                1 : window.gettext('Post Delivery'),
                                // 2: window.gettext('Transportation'),
                                // 3: window.gettext('Terminal'),
                                null: window.gettext('Virtual'),
                            }[item.delivery_method]),
                            label: window.gettext('Delivery Method'),
                        },
                    ],
            ]
            : [
                {field: 'price', label: window.gettext('Price')},
            ],
        {field: item => item.timestamp.toJalali().persian(), label: window.gettext('Date')},


        ...this.props.location.query.item
            ? []
            : [{field: item =>window.pgettext('Orders', 'Orders-Status-' + item.status), label: window.gettext('Status')}],


        {field: item => item.coupon_display != null ?item.coupon_display.persian() :'', label: 'کد تخفیف'},
        {field: item => item.store_item_grades != null ?item.store_item_grades :'-', label: 'پایه'},
        {field: item => item.store_item_step != null ?item.store_item_step.persian() :'-', label: 'مرحله'}, 
        {field: item => item.address_display != null ?item.address_display :'-', label: 'مدرسه'},  

        ...this.props.location.query.item
            ? []
            : this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
                ? [
                    {
                        field: item => item.items.length > 0 && !item.items[0].virtual && (item.status === 2 || item.status === 3)
                            ? <button
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    const win = this.refs.invoice.contentWindow;
                                    ReactDom.unmountComponentAtNode(win.document.getElementById('invoice'));
                                    ReactDom.render(
                                        <span><Invoice {...item} loaded={() => win.print()}/></span>,
                                        win.document.getElementById('invoice'),
                                    );
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Print Invoice')}
                            </button>
                            : null,
                        label: '',
                    },
                ]
                : [
                    {
                        field: item => <button
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            مشاهده سفارش
                        </button>,
                        label: '',
                    },
                    {
                        field: item => item.status === 0
                            ? <button
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={async event => {
                                    event.stopPropagation();
                                    if (!window.confirm(window.gettext('Are you sure you wanna cancel this order?')))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: `/order/${item.id}/cancel/`,
                                        method: 'PATCH',
                                    }));
                                    this.context.store.dispatch([
                                        updateItem({...item, status: 6}, this.props.store.getIn(['paginator', 'elementId'])),
                                        fetchInformation(),
                                    ]);
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Cancel')}
                            </button>
                            : null,
                        label: '',
                    },
                ],

    ]

    filtersSelector = createSelector.bind(this)(
        [
            () => {
                let statuses = this.props.location.query.status || [];
                if (!(statuses instanceof Array))
                    statuses = [statuses];
                return _.map(statuses, status => Number.parseInt(status));
            },
            () => {
                let paymentMethods = this.props.location.query.payment_method || [];
                if (!(paymentMethods instanceof Array))
                    paymentMethods = [paymentMethods];
                return _.map(paymentMethods, paymentMethod => Number.parseInt(paymentMethod));
            },
            () => {
                let deliveryMethods = this.props.location.query.delivery_method || [];
                if (!(deliveryMethods instanceof Array))
                    deliveryMethods = [deliveryMethods];
                return _.map(deliveryMethods, deliveryMethod => Number.parseInt(deliveryMethod));
            },
            () => {
                let representive_id = this.props.location.query.representive_id || [];
                if (!(representive_id instanceof Array))
                    representive_id = [representive_id];
                return _.map(representive_id, deliveryMethod => Number.parseInt(deliveryMethod));
            },
            () => this.props.location.query.item,
            () => this.props.store.getIn(['regionsTreeFilter']),
            () => this.props.store.getIn(['citiesTreeFilter']),
        ],
        (statuses, paymentMethods, deliveryMethods, representive) => [
            {
                field: 'item',
                selected: this.props.location.query.item ? {[this.props.location.query.item.replace(',', ':')]: undefined} : {},
            },
            {
                field: 'status',
                label: window.gettext('Status'),
                component: <div>
                    {_.map(
                        _.filter(_.mapValues(Array(8), (__, index) => index), index => index !== '6'),
                        index => <div
                            key={index}
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}>
                            <Checkbox
                                checked={_.includes(statuses, Number(index))}
                                onChange={this.statusChanged.bind(
                                    this,
                                    index,
                                )}>
                                {window.pgettext('Orders', 'Orders-Status-' + index)}
                            </Checkbox>
                        </div>,
                    )}
                </div>,
                selected: _.mapValues(
                    _.mapKeys(statuses, _.identity),
                    status => window.pgettext('store', 'Status-' + status),
                ),
                remove: id => this.statusChanged(Number(id)),
            },
            ...this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
                ? [
                    ...this.props.location.query.item
                        ? []
                        : [
                            {
                                field: 'payment_method',
                                label: window.gettext('Payment Method'),
                                component: <div>
                                    {_.map(
                                        Array(4),
                                        (__, index) => <div
                                            key={index}
                                            style={{
                                                display: 'block',
                                                float: 'right',
                                                width: '10em',
                                                cursor: 'pointer',
                                            }}>
                                            <Checkbox
                                                checked={_.includes(paymentMethods, index)}
                                                onChange={this.paymentMethodChanged.bind(
                                                    this,
                                                    index,
                                                )}>
                                                {{
                                                    0: window.gettext('Bank gateway'),
                                                    1: window.gettext('Draft'),
                                                    2: window.gettext('No Payment / Free'),
                                                    3: window.gettext('Debtor'),
                                                }[index]}
                                            </Checkbox>
                                        </div>,
                                    )}
                                </div>,
                                selected: _.mapValues(
                                    _.mapKeys(paymentMethods, _.identity),
                                    paymentMethod => ({
                                        0: window.gettext('Bank gateway'),
                                        1: window.gettext('Draft'),
                                        2: window.gettext('No Payment / Free'),
                                        3: window.gettext('Debtor'),
                                    }[paymentMethod]),
                                ),
                                remove: id => this.paymentMethodChanged(Number(id)),
                            },
                            {
                                field: 'delivery_method',
                                label: window.gettext('Delivery Method'),
                                component: <div>
                                    {_.map(
                                        Array(5),
                                        (__, index) => <div
                                            key={index}
                                            style={{
                                                display: 'block',
                                                float: 'right',
                                                width: '10em',
                                                cursor: 'pointer',
                                            }}>
                                            <Checkbox
                                                checked={_.includes(deliveryMethods, index - 1)}
                                                onChange={this.deliveryMethodChanged.bind(
                                                    this,
                                                    index - 1,
                                                )}>
                                                {{
                                                    '-1': window.gettext('Virtual'),
                                                    // 0: window.gettext('Bespoke Post'),
                                                    // 1: window.gettext('Pishtaz Post'),
                                                    1 : window.gettext('Post Delivery'),
                                                    // 2: window.gettext('Transportation'),
                                                    // 3: window.gettext('Terminal'),
                                                }[index - 1]}
                                            </Checkbox>
                                        </div>,
                                    )}
                                </div>,
                                selected: _.mapValues(
                                    _.mapKeys(deliveryMethods, method => method == -1 ? 'None' : method),
                                    deliveryMethod => ({
                                        '-1': window.gettext('Virtual'),
                                        // 0: window.gettext('Bespoke Post'),
                                        // 1: window.gettext('Pishtaz Post'),
                                        1 : window.gettext('Post Delivery'),
                                        // 2: window.gettext('Transportation'),
                                        // 3: window.gettext('Terminal'),
                                    }[deliveryMethod]),
                                ),
                                remove: id => this.deliveryMethodChanged(id === 'None' ? -1 : Number(id)),
                            },
                        ],
                    {
                        field: 'city__region',
                        label: window.gettext('Region'),
                        component: <div style={{fontSize: '.8rem'}}>
                            <Tree
                                store={this.props.store.get('regionsTreeFilter')}
                                readonly
                                header
                                resource='region'
                                itemLabel='name'
                                label={window.gettext('Region')}
                            />
                        </div>,
                        selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                        remove: id => this.context.store.dispatch(removeItemSelection(
                            id,
                            'region',
                            this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                        )),
                    },
                    {
                        field: 'city',
                        label: window.gettext('City'),
                        component: <div style={{fontSize: '.8rem'}}>
                            <Tree
                                store={this.props.store.get('citiesTreeFilter')}
                                readonly
                                header
                                resource='city'
                                itemLabel={city => `${city.region_display} - ${city.name}`}
                                filter={{
                                    region: this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                                }}
                                label={window.gettext('City')}
                            />
                        </div>,
                        selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                        remove: id => this.context.store.dispatch(removeItemSelection(
                            id,
                            'city',
                            this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                        )),
                    },
                    {
                        field: 'representive_id',
                        label: window.gettext('Representive Method'),
                        component: <div>
                            {_.map(
                                this.state.representivates ,
                                (__, index) => <div
                                    key={index}
                                    style={{
                                        display: 'block',
                                        float: 'right',
                                        width: '10em',
                                        cursor: 'pointer',
                                    }}>
                                    <Checkbox
                                        checked={_.includes(representive, index)}
                                        onChange={this.representiveMethodChanged.bind(
                                            this,
                                            index,
                                        )}>
                                        {__.title}
                                    </Checkbox>
                                </div>,
                            )}
                        </div>,
                        selected: _.mapValues(
                            _.mapKeys(representive, _.identity),
                            representive => this.state.representivates.at(representive)?.title,
                        ),
                        remove: id => this.representiveMethodChanged(Number(id)),
                    },
                    {
                        field: 'coupon',
                        label: window.gettext('discount code'),
                        component: <div style={{fontSize: '.8rem'}}>
                            <Tree
                                store={this.props.store.get('couponTreeFilter')}
                                readonly
                                header
                                resource='coupon'
                                itemLabel='title'
                                label={window.gettext('discount code')}
                            />
                        </div>,
                        selected: this.props.store.getIn(['couponTreeFilter', 'selected'])?.toJS(),
                        remove: id => this.context.store.dispatch(removeItemSelection(
                            id,
                            'coupon',
                            this.props.store.getIn(['couponTreeFilter', 'elementId']),
                        )),
                    },
                ]
                : [],
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
            () => this.context.user,
        ],
        () => !this.context.user.hasPerm('store.edit')
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        ...this.props.incomplete
                            ? [{
                                label: window.gettext('Remove'),
                                action: async () => {
                                    if (!window.confirm(window.interpolate(
                                        window.gettext('Are you sure you wanna remove %(count)s orders?'),
                                        {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                        true,
                                    )))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: '/incomplete-order/?' + queryString.stringify({
                                            id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                        }),
                                        method: 'DELETE',
                                    }));
                                    this.context.store.dispatch([
                                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                    ]);
                                },
                            }]
                            : [
                                {
                                    label: window.gettext('Mark Returned'),
                                    action: async () => {
                                        if (!window.confirm(window.interpolate(
                                            window.gettext('Are you sure you wanna mark these %(count)s orders returned?'),
                                            {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                            true,
                                        )))
                                            return;
                                        await this.context.store.dispatch(request({
                                            path: '/admin-order/',
                                            body: this.props.store.getIn(['paginator', 'selected']).keySeq().map(id => ({
                                                id,
                                                status: 7,
                                            })).toJS(),
                                            method: 'PATCH',
                                        }));
                                        this.context.store.dispatch([
                                            clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                            paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        ]);
                                    },
                                },
                                ...this.context.user.hasPerm('store.admin')
                                    ? [{
                                        label: window.gettext('Cancel'),
                                        action: async () => {
                                            if (!window.confirm(window.interpolate(
                                                window.gettext('Are you sure you wanna cancel these %(count)s orders?'),
                                                {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                                true,
                                            )))
                                                return;
                                            await this.context.store.dispatch(request({
                                                path: '/admin-order/',
                                                body: this.props.store.getIn(['paginator', 'selected']).keySeq().map(id => ({
                                                    id,
                                                    status: 6,
                                                })).toJS(),
                                                method: 'PATCH',
                                            }));
                                            this.context.store.dispatch([
                                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                            ]);
                                        },
                                    }]
                                    : [],
                            ],
                    ]
                    : []
            ),
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    componentDidMount() {
        // this.fetch.bind(this)();
        this.fetchRepresentivate();
    }

    async fetchRepresentivate(){
        const url = host_v2 + '/api/StoreApi/GetRepresentative';
         const res = await fetch(url);

         const data = await res.json();
         if(data?.errorId === 0)
            this.setState(el=>({...el, representivates: data.result}))
    }

    statusChanged(status, event) {
        if (event)
            event.stopPropagation();
        let statuses = this.props.location.query.status || [];
        if (!(statuses instanceof Array))
            statuses = [statuses];
        statuses = _.map(statuses, status => Number.parseInt(status));
        if (_.includes(statuses, status)) {
            _.remove(statuses, s => s === status);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, status: statuses},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    status: [...statuses, status],
                },
            }));
        }
    }

    paymentMethodChanged(paymentMethod, event) {
        if (event)
            event.stopPropagation();
        let paymentMethods = this.props.location.query.payment_method || [];
        if (!(paymentMethods instanceof Array))
            paymentMethods = [paymentMethods];
        paymentMethods = _.map(paymentMethods, paymentMethods => Number.parseInt(paymentMethods));
        if (_.includes(paymentMethods, paymentMethod)) {
            _.remove(paymentMethods, s => s === paymentMethod);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, 'payment_method': paymentMethods},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    'payment_method': [...paymentMethods, paymentMethod],
                },
            }));
        }
    }

    representiveMethodChanged(paymentMethod, event) {
        if (event)
            event.stopPropagation();
        let paymentMethods = this.props.location.query.payment_method || [];
        if (!(paymentMethods instanceof Array))
            paymentMethods = [paymentMethods];
        paymentMethods = _.map(paymentMethods, paymentMethods => Number.parseInt(paymentMethods));
        if (!event) {
            _.remove(paymentMethods, s => s === paymentMethod);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, 'representive_id': paymentMethods},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    'representive_id': [...paymentMethods, paymentMethod],
                },
            }));
        }
    }

    deliveryMethodChanged(deliveryMethod, event) {
        if (event)
            event.stopPropagation();
        let deliveryMethods = this.props.location.query.delivery_method || [];
        if (!(deliveryMethods instanceof Array))
            deliveryMethods = [deliveryMethods];
        deliveryMethods = _.map(deliveryMethods, deliveryMethods => Number.parseInt(deliveryMethods));
        if (_.includes(deliveryMethods, deliveryMethod)) {
            _.remove(deliveryMethods, s => s === deliveryMethod);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, 'delivery_method': deliveryMethods},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    'delivery_method': [...deliveryMethods, deliveryMethod],
                },
            }));
        }
    }

    tooltip(item) {
        item.timestamp.toJalali();
    }

    render() {
        console.log(this.props.store.getIn(['regionTreeFilter', 'selected']),this.filtersSelector(this.props.store, this.props.location),'this.filtersSelector(this.props.store, this.props.location)')
        if (this.props.params.id)
            return <Order
                id={this.props.params.id}
                statusesTree={this.props.store.get('statusesTree')}
                incomplete={this.props.incomplete}
            />;
        return <span>
            <span style={{display: this.props.children ? 'none' : undefined}}>
                <iframe
                    ref='invoice'
                    style={{width: '0', height: '0', border: 'none'}}
                    srcDoc={`<html>
    <head>
        <style>
            body {
                font-family: IRANSans;
                font-size: .85rem;
            }
            @page {
                size: A5 Landscape;
                margin: 0;
            }
            @media print {
                html, body {
                    margin: 0;
                    width : 210mm;
                    height : 148mm
                    size: auto;
                }
                div {
                    -webkit-print-color-adjust: exact;
                }
            }
        </style>
    </head>
    <body><span id='invoice'><span>1</span><span style='font-weight: 700;'>2</span></span></body>
</html>`}/>
                <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    resource={this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
                        ? this.props.incomplete ? 'incomplete-order' : 'admin-order'
                        : 'order'
                    }
                    style={this.context.user.hasPerm('store.admin') || this.context.user.hasPerm('store.send')
                        ? this.style
                        : undefined
                    }
                    fixedColumns={2}
                    listFields={this.listFields}
                    tooltip={this.tooltip}
                    title={window.gettext('Orders')}
                    selectable={this.context.user.hasPerm('store.edit')}
                    filters={this.filtersSelector(this.props.store, this.props.location)}
                    sorts={this.sorts}
                    pageSize={this.props.pageSize}
                    actions={this.actionsSelector(this.props.store)}
                />
            </span>
            {this.props.children}
        </span>;
    }
}
window.pgettext('store', 'Status--1');
window.pgettext('store', 'Status-0');
window.pgettext('store', 'Status-1');
window.pgettext('store', 'Status-2');
window.pgettext('store', 'Status-3');
window.pgettext('store', 'Status-4');
window.pgettext('store', 'Status-5');
window.pgettext('store', 'Status-6');
window.pgettext('store', 'Status-7');
